import {useEffect} from "react";
import {batch, useDispatch, useSelector} from "react-redux";

import Body from "./Body";
import InnerPageLayout from "../../../components/layouts/InnerPageLayout";
import SphereLoader from "../../../components/loaders/SphereLoader";
import {getDynamicFields} from "../../../store/actions/component.action";
import {getVehicleCategories} from "../../../store/actions/fleet.action";
import {Loading} from "../../../utils/helpers/constants";


const OnboardVehicle = () => {

  const dispatch = useDispatch();
  const {component, fleet} = useSelector(({componentReducer, fleetReducer}) => ({
    component: componentReducer,
    fleet: fleetReducer,
  }));

  const loadState = component.loadingDynamicFields !== Loading.SUCCESS || fleet.loadingCategories !== Loading.SUCCESS;

  useEffect(() => {
    batch(() => {
      dispatch(getVehicleCategories());
      dispatch(getDynamicFields('FLT'));
    });
  }, []);

  return (
    <InnerPageLayout>
      {loadState ? <SphereLoader/> : <Body categories={fleet.categories} dynamicFields={component.dynamicFields['FLT']}/>}
    </InnerPageLayout>
  );
}

export default OnboardVehicle;
